import React, { Component } from 'react';
import './Home.css';
import { Container, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CheeseburgerMenu from 'cheeseburger-menu';
import HamburgerMenu from 'react-hamburger-menu';
import Collapsible from 'react-collapsible';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: '1',
            menuOpen: false
        };
        this.toggle = props.toggle;
    }

    openMenu() {
        this.setState({ menuOpen: true })
    }

    closeMenu() {
        this.setState({ menuOpen: false })
    }

    handleClick() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        Container.propTypes = {
            fluid:  PropTypes.bool
        }

        return (
                    <Row className="headerRow removePadding removeMargin">
                        <Col className="verticalAlign"
                            xl="1" lg="1" md="1" sm="1" xs="2">
                            <img className="headerLogo" src={require("./Content/Images/logo.png")} alt="FB" />
                        </Col>
                        <Col className="verticalAlign" xl="10" lg="10" md="10" sm="9" xs="8">
                            <div className="headerTitle">Bizwell Technologies</div>
                        </Col>
                        <Col className="verticalAlign"
                             xl="1" lg="1" md="1" sm="1" xs="2">
                            <CheeseburgerMenu
                                right={true}
                                isOpen={this.state.menuOpen}
                                closeCallback={this.closeMenu.bind(this)}
                                backgroundColor="#fff">
                                <Nav tabs className="navBar">
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.props.state.activeTab === '1' })} onClick={() => { this.props.toggle('1'); }}>
                                            Home
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.props.state.activeTab === '2' })} onClick={() => { this.props.toggle('2'); }}>
                                            Profile
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <div className="CollapsibleContainer">
                                            <Collapsible trigger="Projects">
                                                <Nav>
                                                    <NavItem>
                                                        <a target="_blank" rel="noopener noreferrer" href="http://www.gsrijhwani.com">G.S.Rijhwani &amp; Co</a>
                                                    </NavItem>
                                                    <NavItem>
                                                        <a target="_blank" rel="noopener noreferrer" href="Welcome.html">Travelers Reach</a>
                                                    </NavItem>
                                                    <NavItem>
                                                        <a target="_blank" rel="noopener noreferrer" href="Welcome.html">Adolescent Recipes</a>
                                                    </NavItem>
                                                </Nav>
                                            </Collapsible>
                                        </div>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.props.state.activeTab === '3' })} onClick={() => { this.props.toggle('3'); }}>
                                            About
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.props.state.activeTab === '4' })} onClick={() => { this.props.toggle('4'); }}>
                                            Contact
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </CheeseburgerMenu>
                            <HamburgerMenu
                                isOpen={this.state.menuOpen}
                                menuClicked={this.openMenu.bind(this)}
                                width={30}
                                height={20}
                                strokeWidth={3}
                                rotate={0}
                                color='white'
                                borderRadius={0}
                                animationDuration={0.5}/>
                        </Col>
                    </Row>
        );
    }
}
export default Header;
